import { render, staticRenderFns } from "./BaseDetailsIcon.vue?vue&type=template&id=ba8e9644"
import script from "./BaseDetailsIcon.vue?vue&type=script&lang=js"
export * from "./BaseDetailsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports